import type { Location, NavigateFunction, NavigationType, PathMatch } from 'react-router';

import { MatchPattern, useRouter } from './useRouter';

export type RouterHooksHOCProps = {
  location: Location;
  navigate: NavigateFunction;
  navigationType: NavigationType;
  pathname: string;
  push: NavigateFunction;
  query: null | string | string[] | undefined;
  replace: (path: any) => void;
};

export const withRouter = (Component: any) => (props: any) => {
  const router = useRouter();

  const match: Record<string, PathMatch<string>> = Object.values(MatchPattern).reduce((accumulator, pattern) => {
    accumulator[pattern] = router.match(pattern);

    return accumulator;
  }, {});

  return <Component match={match} router={router} {...props} />;
};
